import { useState, useEffect } from 'react';
import { getUsersData } from './customUtil';
import { useSnackbar } from '../../../../Components/Snackbar/snackBarProvider';

const useUsers = () => {
  const { snackbarOpen } = useSnackbar();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    getUsersData(setRows, snackbarOpen);
  }, [snackbarOpen]);

  return { rows, setRows };
};

export default useUsers;
